import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//
import {
  faFileInvoiceDollar,
  faMoneyBillTransfer,
  faBagShopping,
  faShieldHalved,
  faCreditCard,
  faCircleCheck,
  faTriangleExclamation,
  faCircleXmark,
  faCircleInfo,
  faChartColumn,
  faArrowRotateLeft,
  faArrowTrendUp,
  faArrowTrendDown,
  faChevronUp,
  faFire,
  faUserSlash,
  faUserCheck,
  faCommentDots,
  faCalendarDays,
  faCalendarDay,
  faClipboard,
  faHeartPulse,
  faLockOpen,
  faPause,
  faPlayCircle,
  faServer,
  faMicrochip,
  faTabletAlt,
  faFingerprint,
  faCalendar,
  faCalendarPlus,
  faHandPointer,
  faSpa,
  faStoreAltSlash,
  faCartPlus,
  faReceipt,
  faBox,
  faTags,
  faBook,
  faPlay,
  faCancel,
  faStop,
  faVideoSlash,
  faVideoCamera,
  faHeadset,
  faSync,
  faSyncAlt,
  faChevronRight,
  faBriefcaseMedical,
  faTv,
  faRectangleAd,
  faGift,
  faPerson,
  faPersonDress,
  faFemale,
  faMale,
  faCoins,
  faScaleUnbalanced,
  faScaleUnbalancedFlip,
  faSackDollar,
  faHandHoldingDollar,
  faFileInvoice,
  faMoneyBillTrendUp,
  faGears,
  faJetFighterUp,
  faShop,
  faUserTie,
  faRepeat,
  faGear,
  faKey,
  faArrowAltCircleLeft,
  faFile,
  faFilePdf,
  faPaperPlane,
  faEnvelope,
  faHourglass,
  faHourglass1,
  faHourglass2,
  faHourglass3,
  faHourglassEnd,
  faHourglassStart,
  faHourglassHalf,
  faStoreAlt,
  faWarning,
  faArrowRight,
  faFilter,
  faEye,
  faDashboard,
  faTrophy,
  faShapes,
  faSubscript,
  faUserClock,
  faHistory,
  faChartBar,
  faChartPie,
  faClockFour,
  faCheck,
  faSearch,
  faPlusMinus,
  faEdit,
  faUserEdit,
  faTrash,
  faMoneyCheckDollar,
  faDollar,
  faMoneyCheckAlt,
  faMoneyCheck,
  faDollarSign,
  faHome,
  faUser,
  faUsers,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faBell,
  faClock,
  faCoffee,
  faCube,
  faAd,
  faPlus,
  faConciergeBell,
  faWrench,
  faTable,
  faTasks,
  faChartLine,
  faStore,
  faCubes,
  faChevronDown,
  faBiking,
  faCalendarAlt,
  faCalendarCheck,
  faWalking,
  faBars,
  faPen,
  faTrashAlt,
  faFighterJet,
  faGlobe,
  faObjectGroup,
  faToggleOn,
  faToggleOff,
  faCloudUploadAlt,
  faCamera,
  faChair,
  faPercent,
  faShare,
  faSitemap,
  faPlusCircle,
  faCheckSquare,
  faMoneyBill,
  faQrcode,
  faArrowDown,
  faArrowUp,
  faCirclePlay,
  faPrint,
  faMailBulk,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faFileInvoiceDollar,
  faMoneyBillTransfer,
  faBagShopping,
  faShieldHalved,
  faCreditCard,
  faCircleCheck,
  faTriangleExclamation,
  faCircleXmark,
  faCircleInfo,

  faChartColumn,
  faArrowRotateLeft,
  faArrowTrendUp,
  faArrowTrendDown,
  faChevronUp,
  faFire,
  faUserSlash,
  faUserCheck,
  faCommentDots,
  faCalendarDays,
  faCalendarDay,
  faClipboard,
  faHeartPulse,
  faLockOpen,
  faPause,
  faPlayCircle,
  faMicrochip,
  faServer,
  faTabletAlt,
  faFingerprint,
  faCalendar,
  faCalendarPlus,
  faHandPointer,
  faSpa,
  faStoreAltSlash,
  faCartPlus,
  faReceipt,
  faBox,
  faTags,
  faBook,
  faPlay,
  faCancel,
  faStop,
  faVideoCamera,
  faVideoSlash,
  faHeadset,
  faSync,
  faSyncAlt,
  faTv,
  faBriefcaseMedical,
  faChevronRight,
  faRectangleAd,
  faGift,
  faPerson,
  faPersonDress,
  faFemale,
  faMale,
  faCoins,
  faScaleUnbalanced,
  faScaleUnbalancedFlip,
  faSackDollar,
  faHandHoldingDollar,
  faFileInvoice,
  faMoneyBillTrendUp,
  faGears,
  faJetFighterUp,
  faShop,
  faRepeat,
  faUserTie,
  faGear,
  faKey,
  faArrowAltCircleLeft,
  faFile,
  faFilePdf,
  faPaperPlane,
  faEnvelope,
  faHourglass1,
  faHourglass2,
  faHourglass3,
  faHourglassEnd,
  faHourglassStart,
  faHourglass,
  faStoreAlt,
  faWarning,
  faArrowRight,
  faFilter,
  faEye,
  faDashboard,
  faTrophy,
  faShapes,
  faSubscript,
  faUserClock,
  faHistory,
  faDollarSign,
  faMoneyCheckAlt,
  faMoneyCheck,
  faChartBar,
  faChartPie,
  faClockFour,
  faCheck,
  faSearch,
  faPlusMinus,
  faEdit,
  faUserEdit,
  faTrash,
  faDollar,
  faMoneyCheckDollar,
  faHome,
  faUser,
  faUsers,
  faUserPlus,
  faPlus,
  faSignInAlt,
  faSignOutAlt,
  faBell,
  faClock,
  faCoffee,
  faCube,
  faConciergeBell,
  faWrench,
  faTable,
  faTasks,
  faChartLine,
  faStore,
  faCubes,
  faChevronDown,
  faBiking,
  faCalendarAlt,
  faCalendarCheck,
  faWalking,
  faBars,
  faPen,
  faTrashAlt,
  faFighterJet,
  faToggleOn,
  faToggleOff,
  faCloudUploadAlt,
  faCamera,
  faCheckSquare,
  faChair,
  faShare,
  faSitemap,
  faGlobe,
  faObjectGroup,
  faPlusCircle,
  faPercent,
  faMoneyBill,
  faQrcode,
  faArrowDown,
  faArrowUp,
  faCirclePlay,
  faPrint,
  faMailBulk,
  faCopy,
);

export { FontAwesomeIcon };
